import React from "react";
import { useRateCardContext, useServicesContext } from "components/ratecard/contextProviders";
import { Spin } from "antd";

import EnableService from "../EnableService";
import { useParams } from "react-router-dom";

interface Props {
  serviceName: string;
}

/**
 * Component that handles visibility of a rate card
 * or Component to enable service.
 * @param {Props} props Component properties
 */
const ServiceRate: React.FC<Props> = ({ children, serviceName }) => {
  const { rateCard, enableRateCard, status, createRateCardStatus } = useRateCardContext();
  const { currentService } = useServicesContext();
  const params = useParams<{ service_id: string }>();

  // Check if user is on NS Settings Tab using the service_id in the params.
  // When on NS Settings Tab, never show the enable service card.
  const hideEnableServiceCard = params?.service_id && params.service_id === "nsSettings";

  return (
    <Spin spinning={status === "loading"}>
      {/* If there is no current service selected, it defaults to nsSettings */}
      {rateCard || hideEnableServiceCard ? (
        <>{children}</>
      ) : (
        <EnableService
          serviceName={currentService?.name || serviceName}
          onEnable={() => enableRateCard()}
          createRateCardStatus={createRateCardStatus}
        />
      )}
    </Spin>
  );
};

export default ServiceRate;
